// extracted by mini-css-extract-plugin
module.exports = {"DocsPageWrapper":"DocsPageWrapper_DocsPageWrapper__jJwdS"};